<div
    #modal="bs-modal"
    [config]="{ backdrop: 'static' }"
    appBsModal
    aria-hidden="true"
    aria-labelledby="modal"
    class="modal fade"
    role="dialog"
    tabindex="-1"
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {{ "DelegateActivities" | localize }}
                </h4>

                <button
                    (click)="clearDelegation()"
                    class="btn font-weight-bold clear-button"
                    type="button"
                >
                    {{ "ClearDelegation" | localize }}
                </button>
            </div>

            <div class="body mat-calendar-style">

                <mat-calendar #calendar
                (selectedChange)="selectDate($event,calendar)"
                [dateClass]="isSelected">
                </mat-calendar>

                <form [formGroup]="searchForm" class="input-group mb-4">
                    <div class="input-group-prepend">
                        <span class="input-group-text"
                            ><i class="fa fa-search"></i
                        ></span>
                    </div>
                    <input
                        [placeholder]="l('SearchSupervisorThreeDot')"
                        class="form-control m-input"
                        formControlName="search"
                        type="text"
                    />
                </form>

                <div *ngIf="showList" class="mb-4 supervisor-list">
                    <ng-container *ngIf="supervisorList.length; else noData">
                        <div
                            *ngFor="let supervisor of supervisorList"
                            class="mb-3 supervisor-row"
                        >
                            <span class="supervisor-details">
                                <span class="font-weight-bold">
                                    {{ getSupervisorFullName(supervisor) }}
                                </span>
                                <span class="ml-2 supervisor-email">
                                    ({{ supervisor.staffUser.emailAddress }})
                                </span>
                            </span>

                            <button
                                (click)="selectSupervisor(supervisor)"
                                class="btn btn-outline-primary"
                                type="button"
                            >
                                {{ "Select" | localize }}
                            </button>
                        </div>
                    </ng-container>

                    <ng-template #noData>
                        {{ "NoDataMatchingTheFilter" | localize }}
                    </ng-template>
                </div>

                <div
                    *ngIf="delegationSupervisor"
                    class="mb-4 selected-supervisor"
                >
                    <div class="mr-4 selected-supervisor-check">
                        <i class="fa fa-check"></i>
                    </div>

                    <div>
                        <span class="font-weight-bold">
                            {{ getSupervisorFullName(delegationSupervisor) }}
                        </span>
                        <span class="ml-2 supervisor-email">
                            {{ delegationSupervisor.staffUser.emailAddress }}
                        </span>
                    </div>
                </div>
            </div>

            <div class="footer">
                <button
                    (click)="close()"
                    class="btn font-weight-bold"
                    type="button"
                >
                    {{ "Cancel" | localize }}
                </button>
                <button
                    (click)="delegate()"
                    [disabled]="
                        !delegationSupervisor || !IsDateAvilabel()
                    "
                    class="btn btn-primary font-weight-bold"
                    type="button"
                >
                    {{ "Done" | localize }}
                </button>
            </div>
        </div>
    </div>
</div>
